import { render, staticRenderFns } from "./NavigationSettings.vue?vue&type=template&id=51c16984&scoped=true&"
import script from "./NavigationSettings.vue?vue&type=script&lang=js&"
export * from "./NavigationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSettings.vue?vue&type=style&index=0&id=51c16984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c16984",
  null
  
)

export default component.exports